import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { first } from 'rxjs/operators';
import { UtilService } from './../../../../shared/services/util/util.service';
import { EventsService } from './../../../../shared/services';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-share-icons',
  templateUrl: './footer-share-icons.component.html',
  styleUrls: ['./footer-share-icons.component.scss']
})
export class FooterShareIconsComponent implements OnInit {

  constructor(
    private eventService: EventsService,
    private utilService: UtilService,
    private variableService: VariablesService
  ) { }

  ngOnInit() {
  }

  whatsappChat() {
    const payload = {
      eventName: 'wa_chat_with_us',
      event_type: 'campaign',
      info_1: 'type',
      info_2: 5
    };
    this.eventService.sendSystemEvent(payload).pipe(first()).subscribe(
      (data) => {
        this.utilService.nativeNavigation('https://api.whatsapp.com/send?phone=91' + this.variableService.contactUsMobNumber, true);
      }
    );
  }

}
